import { render } from "./Register.vue?vue&type=template&id=4efb6cb4&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "@/assets/styles/auth.css?vue&type=style&index=0&id=4efb6cb4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efb6cb4"]])

export default __exports__